export default __webpack_public_path__ + "static/media/navegacao1_recorte.c5d66ce7.webp";